
import React from "react";
import { FormFieldType } from "@/types/form";
import { InstructionBox } from "../components";

interface InstructionProps {
  element: FormFieldType;
}

export const Instruction: React.FC<InstructionProps> = ({ element }) => {
  return (
    <InstructionBox>
      <div className="whitespace-pre-line text-sm">{element.text}</div>
    </InstructionBox>
  );
};

export default Instruction;
